import type { ReactNode } from "react";
import React, { useId } from "react";
import type * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { cn } from "@/lib/utils";

interface RadioOption {
  value: string;
  label: ReactNode;
}

interface RadioGroupFieldProps {
  options: Array<RadioOption>;
}

export type RadioGroupCustomProps = React.ComponentPropsWithoutRef<
  typeof RadioGroupPrimitive.Root
> &
  RadioGroupFieldProps;

const RadioGroupCustom = React.forwardRef<
  React.ComponentRef<typeof RadioGroupPrimitive.Root> & RadioGroupFieldProps,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root> &
    RadioGroupFieldProps
>(({ options, className, ...props }, ref) => {
  const id = useId();
  return (
    <RadioGroup
      ref={ref}
      {...props}
      className={cn("min-h-[40px] w-full", className)}
    >
      {options.map((item) => (
        <div className="flex items-center space-x-2" key={item.value}>
          <RadioGroupItem value={item.value} id={id + item.value} />
          <label className="text-sm cursor-pointer" htmlFor={id + item.value}>
            {item.label}
          </label>
        </div>
      ))}
    </RadioGroup>
  );
});

export { RadioGroupCustom };
